import React from "react";
import {
  convertToNumber,
  removeCurrency,
} from "../../../utils/convertToNumber";

const AirArabiaPassengerPricing = ({
  label,
  count,
  priceIndex,
  AirPricing,
  rateDifference,
}) => {
  const formatPrice = (price) => {
    if (rateDifference > 1) {
      const convertedPrice = (
        removeCurrency(price.amount) * rateDifference
      ).toFixed(2);

      return `${convertToNumber(String(convertedPrice))} ${price.currency}`;
    }

    return `${convertToNumber(String(price.amount))} ${price.currency}`;
  };

  return (
    count > 0 && (
      <div className="flex justify-between text-neutral-6000">
        <div>{`${count} * ${label}`}</div>
        <div>{formatPrice(AirPricing)}</div>
      </div>
    )
  );
};

export default AirArabiaPassengerPricing;
